import { render, staticRenderFns } from "./revenue.vue?vue&type=template&id=4890a321&scoped=true"
import script from "./revenue.vue?vue&type=script&lang=js"
export * from "./revenue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4890a321",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/private/workspaces/smart-life/smart-life-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4890a321')) {
      api.createRecord('4890a321', component.options)
    } else {
      api.reload('4890a321', component.options)
    }
    module.hot.accept("./revenue.vue?vue&type=template&id=4890a321&scoped=true", function () {
      api.rerender('4890a321', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/financial/report/revenue.vue"
export default component.exports